module.exports = __webpack_public_path__ + "img/github.16467be4.svg";